module.exports = __webpack_public_path__ + "assets/img/1_1788_big.38a6cec6.jpg";